const { REACT_APP_NAME } = process.env;

export const setStorage = async (data, storageName = REACT_APP_NAME) =>
  await localStorage.setItem(storageName, JSON.stringify(data));

export const getStorage = async (storageName = REACT_APP_NAME) => {
  const user = await JSON.parse(localStorage.getItem(storageName));

  return user ? user : {};
};

export const clearStorage = async (key) => {
  if (key) {
    await localStorage.removeItem(key);
    return {};
  }
  const user = await localStorage.clear();

  return user ? user : {};
};
